import { NotificationActions } from './Notification.reducer'


const NotificationActionCreatorsMapping = {
  openNotificationModal: () => ({ type: NotificationActions.OPEN_NOTIFICATION_MODAL }),
  closeNotificationModal: () => ({ type: NotificationActions.CLOSE_NOTIFICATION_MODAL }),
  toggleNotificationSettings: () => ({ type: NotificationActions.TOGGLE_NOTIFICATION_SETTINGS }),
}

export default NotificationActionCreatorsMapping
